import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { AddShiftPopup } from './model';

import { ActionLoadingIndicator } from 'core/actionloadingindicator/view';
import { ErrorModal } from 'core/validationerror/view';
import { PCModal } from 'portcall/pcmodal/view';
import { TypeaheadInput } from 'portcall/typeahead/view';

export const AddShiftPopupView = SuperCritical(({ modelContainer } : { modelContainer : () => AddShiftPopup | null }) => {
    const m = modelContainer();
    return (
        <div>
            <PCModal className="addshiftpopupcomponent" shown={() => !!m} onBackDropClick={m?.Cancel}>
                <div className="modal-content pc-card">
                    <div className="pc-card-header pc-card-title">Add a Shift</div>
                    <div className="pc-text-smalllabel">
                        Select the location the vessel will shift to.
                        This will change the current OUT movement to a SHIFT and add a new OUT movement.
                    </div>
                    {m && <AddShiftPopupMain model={m} />}
                </div>
            </PCModal>
            {m && <ErrorModal errors={m.AgentRestrictions} shown={m.ShowAgentRestrictions} title="There is an issue with this shift" />}
        </div>
    );
});

let AddShiftPopupMain = SuperCritical(({ model: m } : { model : AddShiftPopup }) =>
    <div>
        <div className="berth-container">
            <TypeaheadInput className="search-filter" model={m.BerthTypeahead}
                placeholder="Berth ..." />
        </div>
        <div className="controls">
            <a href="" onClick={noDefault(m.Cancel)}>Cancel</a>
            <button className="pc-button add-shift-btn"
                disabled={!m.CanSubmit()}
                onClick={m.Submit}>
                Add Shift
            </button>
        </div>
        <ActionLoadingIndicator loading={m.Submitting} />
    </div>
);


// WEBPACK FOOTER //
// ./apps/pilots/addshiftpopup/view.tsx